// Lumeda PDP — interactions
// 1. Sticky header/footer CTA reveal on scroll past hero
// 2. Gallery thumbnail click → swap main image
// 3. Quantity +/- buttons
// 4. Sticky CTA "Add to cart" → submit the in-page form
// 5. Variant option click → select hidden id

// Always start at the top on load/refresh
if (history.scrollRestoration) { history.scrollRestoration = 'manual'; }
window.scrollTo(0, 0);

// ----- Cart drawer: ATC interception -----
// product-form.js is NOT loaded on this custom PDP template, so form submits
// would normally navigate away. We intercept the submit ourselves.
(function () {
  var _origFetch = window.fetch;

  function openDrawer(parsedState) {
    var drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!drawer) return;

    // Remove is-empty that Dawn sets when the cart is emptied — must happen
    // before renderContents or the items stay hidden by CSS
    drawer.classList.remove('is-empty');
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');

    // Path A: we have section HTML from /cart/add.js — use renderContents
    // (Dawn's own method: updates #CartDrawer innerHTML then calls open())
    if (parsedState && parsedState.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(parsedState);
      return;
    }

    // Path B: no section data — open manually then fetch fresh content
    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', function () {
      if (typeof drawer.close === 'function') drawer.close();
    }, { once: true });

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    _origFetch(cartUrl + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        drawer.classList.remove('is-empty');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
          var target = document.querySelector(sel);
          var source = doc.querySelector(sel);
          if (target && source) target.replaceWith(source);
        });
      })
      .catch(function () {});
  }

  // PRIMARY: intercept native form submit before it navigates
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.dataset.type !== 'add-to-cart-form') return;
    var drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!drawer) return; // no drawer/notification → let it navigate

    e.preventDefault();
    e.stopImmediatePropagation();

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');

    var sectionIds = (typeof drawer.getSectionsToRender === 'function')
      ? drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : 'cart-drawer,cart-icon-bubble';

    var formData = new FormData(form);
    formData.append('sections', sectionIds);
    formData.append('sections_url', window.location.pathname);

    _origFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(function (r) { return r.json(); })
    .then(function (parsedState) {
      if (submitBtn) submitBtn.removeAttribute('aria-disabled');
      if (parsedState.status) return; // sold out / error
      openDrawer(parsedState);
    })
    .catch(function () {
      if (submitBtn) submitBtn.removeAttribute('aria-disabled');
    });
  }, true); // capture phase — fires before Dawn or any other handler

  // BACKUP: wrap window.fetch for Pumper/app AJAX adds
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
    if (url.indexOf('/cart/add') !== -1) {
      return _origFetch.apply(this, arguments).then(function (res) {
        if (res.ok) {
          res.clone().json().then(function (data) {
            openDrawer(data.sections ? data : null);
          }).catch(function () { openDrawer(null); });
        }
        return res;
      });
    }
    return _origFetch.apply(this, arguments);
  };

  // XHR backup
  var _xhrOpen = XMLHttpRequest.prototype.open;
  var _xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) {
    this._lumedaUrl = url;
    return _xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._lumedaUrl && this._lumedaUrl.indexOf('/cart/add') !== -1) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) openDrawer(null);
      });
    }
    return _xhrSend.apply(this, arguments);
  };
})();

(function () {
  'use strict';

  function initPDP() {
    // ----- Sticky CTA reveal -----
    const sticky = document.querySelector('[data-sticky-cta]');
    const hero = document.getElementById('pdp-hero');
    if (sticky && hero) {
      sticky.removeAttribute('hidden');
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            sticky.dataset.active = e.isIntersecting ? 'false' : 'true';
          });
        },
        { rootMargin: '-200px 0px 0px 0px', threshold: 0 }
      );
      obs.observe(hero);
    }

    // ----- Sticky CTA → submit form -----
    document.querySelectorAll('[data-sticky-add]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const form = document.querySelector('[data-type="add-to-cart-form"]');
        if (!form) return;
        const submitBtn = form.querySelector('button[type=submit]');
        if (submitBtn && !submitBtn.disabled) form.requestSubmit(submitBtn);
      });
    });

    // ----- Gallery: arrows + thumbs + swipe + dots -----
    const mainImg  = document.getElementById('lumedaGalleryMainImg');
    const galleryEl = document.getElementById('lumedaGalleryMain');
    const prevBtn  = document.getElementById('lumedaGalleryPrev');
    const nextBtn  = document.getElementById('lumedaGalleryNext');
    const thumbs   = Array.from(document.querySelectorAll('.lumeda-pdp__thumb'));

    if (mainImg && thumbs.length) {
      const urls = thumbs.map((t) => t.dataset.mediaUrl).filter(Boolean);
      let current = 0;

      // Build dot indicators
      const thumbsWrap = document.querySelector('.lumeda-pdp__gallery-thumbs');
      let dots = [];
      if (thumbsWrap && urls.length > 1) {
        const dotsEl = document.createElement('div');
        dotsEl.className = 'lumeda-pdp__gallery-dots';
        urls.forEach((_, i) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.className = 'lumeda-pdp__gallery-dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Image ' + (i + 1));
          d.addEventListener('click', () => goTo(i));
          dotsEl.appendChild(d);
          dots.push(d);
        });
        thumbsWrap.parentElement.insertBefore(dotsEl, thumbsWrap.nextSibling);
      }

      function goTo(idx) {
        if (idx < 0) idx = urls.length - 1;
        if (idx >= urls.length) idx = 0;
        if (idx === current && urls.length > 1) return;
        current = idx;

        // Swap immediately, then let the opacity transition give it a quick polish fade-in
        mainImg.src = urls[current];
        mainImg.srcset = urls[current] + ' 1200w';
        mainImg.style.opacity = '0';
        requestAnimationFrame(() => {
          mainImg.style.opacity = '1';
        });

        // Sync thumbs
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === current));
        // Sync dots
        dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      }

      // Thumb clicks
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));

      // Arrow clicks
      if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

      // Touch swipe
      let touchX = 0;
      if (galleryEl) {
        galleryEl.addEventListener('touchstart', (e) => {
          touchX = e.changedTouches[0].clientX;
        }, { passive: true });
        galleryEl.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - touchX;
          if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
        }, { passive: true });
      }

      // Keyboard arrows when gallery is focused
      if (galleryEl) {
        galleryEl.setAttribute('tabindex', '0');
        galleryEl.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') goTo(current - 1);
          if (e.key === 'ArrowRight') goTo(current + 1);
        });
      }
    }

    // ----- Quantity +/- -----
    document.querySelectorAll('[data-qty-action]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('.lumeda-pdp__qty-input');
        if (!input) return;
        const cur = parseInt(input.value, 10) || 1;
        const min = parseInt(input.min, 10) || 1;
        const max = parseInt(input.max, 10) || 99;
        const next = btn.dataset.qtyAction === 'inc' ? Math.min(cur + 1, max) : Math.max(cur - 1, min);
        input.value = next;
      });
    });

    // ----- Variant option select -----
    document.querySelectorAll('.lumeda-pdp__variant').forEach((variantGroup) => {
      const buttons = variantGroup.querySelectorAll('.lumeda-pdp__variant-option');
      const selectedLabel = variantGroup.querySelector('.lumeda-pdp__variant-selected');
      buttons.forEach((b) =>
        b.addEventListener('click', () => {
          buttons.forEach((x) => x.classList.remove('is-selected'));
          b.classList.add('is-selected');
          if (selectedLabel) selectedLabel.textContent = b.dataset.optionValue;
        })
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPDP);
  } else {
    initPDP();
  }
  document.addEventListener('shopify:section:load', initPDP);
})();


/* =====================================================================
   UGC VIDEO CAROUSEL — controls
   ===================================================================== */
(function () {
  function initUGC() {
    var sections = document.querySelectorAll('.lumeda-pdp__ugc');
    sections.forEach(function (section) {
      var track = section.querySelector('[data-ugc-track]');
      var prev  = section.querySelector('.lumeda-pdp__ugc-nav--prev');
      var next  = section.querySelector('.lumeda-pdp__ugc-nav--next');
      if (!track) return;

      // ------- arrow scroll -------
      function scrollByCard(dir) {
        var card = track.querySelector('.lumeda-pdp__ugc-card');
        if (!card) return;
        var step = card.getBoundingClientRect().width + 18; // gap
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });

      // ------- per-card behavior -------
      var cards = section.querySelectorAll('.lumeda-pdp__ugc-card');
      cards.forEach(function (card) {
        var video = card.querySelector('[data-ugc-video]');
        var muteBtn = card.querySelector('[data-ugc-mute]');
        var playBtn = card.querySelector('[data-ugc-play]');
        var media = card.querySelector('.lumeda-pdp__ugc-media');
        if (!video) return;

        var muteOn  = card.querySelector('.lumeda-pdp__ugc-mute-on');
        var muteOff = card.querySelector('.lumeda-pdp__ugc-mute-off');
        var playIco = card.querySelector('.lumeda-pdp__ugc-play-icon');
        var pauseIco = card.querySelector('.lumeda-pdp__ugc-pause-icon');

        function syncPlayIcon() {
          if (video.paused) {
            card.classList.add('is-paused');
            if (playIco) playIco.style.display = '';
            if (pauseIco) pauseIco.style.display = 'none';
          } else {
            card.classList.remove('is-paused');
            if (playIco) playIco.style.display = 'none';
            if (pauseIco) pauseIco.style.display = '';
          }
        }
        function syncMuteIcon() {
          if (video.muted) {
            if (muteOn) muteOn.style.display = '';
            if (muteOff) muteOff.style.display = 'none';
          } else {
            if (muteOn) muteOn.style.display = 'none';
            if (muteOff) muteOff.style.display = '';
          }
        }
        video.addEventListener('play', syncPlayIcon);
        video.addEventListener('pause', syncPlayIcon);
        video.addEventListener('volumechange', syncMuteIcon);
        syncPlayIcon();
        syncMuteIcon();

        if (muteBtn) {
          muteBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            // mute all other videos when unmuting this one
            if (video.muted) {
              document.querySelectorAll('[data-ugc-video]').forEach(function (v) {
                if (v !== video) v.muted = true;
              });
            }
            video.muted = !video.muted;
          });
        }
        function togglePlay(e) {
          if (e) e.stopPropagation();
          if (video.paused) video.play().catch(function(){});
          else video.pause();
        }
        if (playBtn) playBtn.addEventListener('click', togglePlay);
        if (media)   media.addEventListener('click', togglePlay);
      });

      // ------- IntersectionObserver: pause off-screen, play on-screen -------
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var card = entry.target;
            var video = card.querySelector('[data-ugc-video]');
            if (!video) return;
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              card.classList.add('is-active');
              video.play().catch(function(){});
            } else {
              card.classList.remove('is-active');
              video.pause();
            }
          });
        }, { root: track, threshold: [0, 0.6, 0.9] });
        cards.forEach(function (c) { io.observe(c); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUGC);
  } else {
    initUGC();
  }
  document.addEventListener('shopify:section:load', initUGC);
})();
